module.exports = __webpack_public_path__ + "static/media/proemailAccountTreeBlack.2a2c1abd.svg";